import { devtools } from 'zustand/middleware';

import { type Competition, type CompetitionWishlistItem } from '@app/client/common/structs';
import { create } from '@app/store/zustand/helpers/create';

export type FantasyGameTimeMetadata = {
    gameStarted: boolean;
    gameEnded: boolean;
    submissionsClosed: boolean;
};
export type FantasyGameMetadata = {
    currentGame?: Competition;
    currentGameWishlist?: CompetitionWishlistItem;
    currentGameWishlistId?: string;
    currentCompetitionMax: number;
} & FantasyGameTimeMetadata;

interface FantasyGameMetadataState extends FantasyGameMetadata {
    clearGameMetadata: () => void;
    setGameData: (gameData: FantasyGameMetadata) => void;
    setGameTimesData: (timeData: Partial<FantasyGameTimeMetadata>) => void;
    setCurrentGameWishlist: (currentLineupWishlist: CompetitionWishlistItem) => void;
    setCurrentGameWishlistId: (wishlistId: string) => void;
}

const initialState: FantasyGameMetadata = {
    gameStarted: false,
    gameEnded: false,
    submissionsClosed: false,
    currentGame: undefined,
    currentGameWishlist: undefined,
    currentGameWishlistId: undefined,
    currentCompetitionMax: 0,
};

export const useFantasyMetadataStore = create<FantasyGameMetadataState>()(
    devtools(
        (set) => ({
            ...initialState,
            setGameData: (gameData) => set({ ...gameData }),
            setGameTimesData: (timesData) =>
                set((state) => ({
                    submissionsClosed: timesData.submissionsClosed || state.submissionsClosed,
                    gameStarted: timesData.gameStarted || state.gameStarted,
                    gameEnded: timesData.gameEnded || state.gameEnded,
                })),
            setCurrentGameWishlist: (currentGameWishlist) => set({ currentGameWishlist }),
            setCurrentGameWishlistId: (currentGameWishlistId) => set({ currentGameWishlistId }),
            clearGameMetadata: () => set(initialState),
        }),
        { name: 'fantasy-metadata-storage' },
    ),
);
